import type { ActivityEntityDescriptor } from './types';

/**
 * Реестр дескрипторов сущностей Activity.
 *
 * Ключ — `entity_type` (`repository_code`), диспетчеризация UI-поведения ядра
 * идёт через него. Upsert по ключу — безопасно для dev/HMR.
 */
class ActivityEntityRegistry {
  private static instance: ActivityEntityRegistry | null = null;

  private readonly descriptorsByType = new Map<string, ActivityEntityDescriptor>();

  static getInstance(): ActivityEntityRegistry {
    if (!ActivityEntityRegistry.instance) {
      ActivityEntityRegistry.instance = new ActivityEntityRegistry();
    }
    return ActivityEntityRegistry.instance;
  }

  register(descriptor: ActivityEntityDescriptor): void {
    this.descriptorsByType.set(descriptor.entityType, descriptor);
  }

  get(entityType: string | null | undefined): ActivityEntityDescriptor | null {
    const normalized = entityType?.trim();
    if (!normalized) return null;
    return this.descriptorsByType.get(normalized) ?? null;
  }

  getAll(): ActivityEntityDescriptor[] {
    return Array.from(this.descriptorsByType.values());
  }
}

export const activityEntityRegistry = ActivityEntityRegistry.getInstance();

/**
 * Регистрирует дескриптор сущности в Activity (upsert по `entityType`).
 * Вызывается из bootstrap модуля-владельца сущности.
 */
export function registerActivityEntity(
  descriptor: ActivityEntityDescriptor
): ActivityEntityDescriptor {
  activityEntityRegistry.register(descriptor);
  return descriptor;
}

/** Возвращает дескриптор по `entity_type` или null (fallback-поведение ядра). */
export function getActivityEntityDescriptor(
  entityType: string | null | undefined
): ActivityEntityDescriptor | null {
  return activityEntityRegistry.get(entityType);
}
